import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import AsyncPaginate from "@ROM-components/common/AsyncPaginate";
import { loadOptions as loadPriceListsOptions } from "@ROM/PriceLists/utils";
import { update, fetchCustomer } from "@ROM/Customers/actions";

const unstyledSelectorStyles = {
  control: (provided) => ({
    ...provided,
    boxShadow: "none",
    border: "none",
    minWidth: '200px'
  }),
  menu: (provided) => ({
    ...provided,
    border: 'none',
    width: '100%',
    minWidth: '200px'
  }),
  menuList: (provided) => ({
    ...provided,
    width: '100%'
  })
};

const PriceListDropDown = ({ customer, priceList }) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: null });

  useEffect(() => {
    if (priceList?.attributes?.name) {
      setSelectedOption({
        value: priceList.isDefault ? null : priceList.id,
        label: priceList.attributes.name,
      });
    } else {
      setSelectedOption(null);
    }
  }, [priceList]);

  const handleChange = (newValue) => {
    if (!customer?.id) return;

    setLoading(true);
    setFeedback({ type: null });
    setSelectedOption(newValue);

    const updatePayload = {
      name: customer.attributes.name,
      price_list_id: newValue ? newValue.value : null,
    };

    dispatch(update(customer.id, updatePayload))
    .then((response) => {
      if (response.error) {
        setFeedback({ type: 'error' });
        setLoading(false);
        setSelectedOption(null);
      } else {
        dispatch(fetchCustomer(customer.id)); // Add this line
        setLoading(false);
        setFeedback({ type: 'success' });
        setTimeout(() => setFeedback({ type: null }), 2000);
      }
    })
  };

  return (
    <div className="position-relative">
      <AsyncPaginate
        value={selectedOption}
        loadOptions={loadPriceListsOptions}
        onChange={handleChange}
        placeholder="Select Price List"
        additional={{ page: 1 }}
        isDisabled={loading}
        styles={unstyledSelectorStyles}
        cacheUniqs={[customer.id]}
      />

      {feedback.type && (
        <div 
          className="position-absolute" 
          style={{ 
            right: -25,
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          {feedback.type === 'success' && (
            <i className="fas fa-check text-success" />
          )}
          {feedback.type === 'error' && (
            <i className="fas fa-times text-danger" />
          )}
        </div>
      )}
    </div>
  );
};

PriceListDropDown.propTypes = {
  customer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      name: PropTypes.string.isRequired,
      companyId: PropTypes.number,
      invoiceNumberPrefix: PropTypes.string,
      isActive: PropTypes.bool,
      taxExempt: PropTypes.bool,
      primaryContact: PropTypes.string,
      regionId: PropTypes.number,
      needsApproval: PropTypes.bool,
      stripeId: PropTypes.string
    }).isRequired
  }).isRequired,
  priceList: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      name: PropTypes.string
    })
  })
};

PriceListDropDown.defaultProps = {
  priceList: null
};

export default PriceListDropDown;